import request from '@/router/axios';
const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/sys' : '/sys'

/**
 * 查询快捷菜单
 * @param obj
 */
export function getShortcutMenuByMemberId(obj) {
  return request({
    url: urlPrefix + '/pms-shortcut-menu/shortcut/menu/'+obj,
    method: 'get',
    //params: obj,
  });
}

/**
 *  保存快捷菜单
 */
export function saveShortcutMenu(obj) {
  return request({
    url: urlPrefix + '/pms-shortcut-menu/save/shortcut/menu',
    method: 'Post',
    data: obj,
  });
}
/**
 *  得行业分类
 */
export function getIndustryClass() {
  return request({
    url:  '/cus/cus/cus/industry/class',
    method: 'get',
   // data: obj,
  });
}


